import sentry from '@shared/services/sentry';
import { useCallback, useEffect, useRef, useState } from 'react';
import generatePDF, { Resolution } from 'react-to-pdf';

export default function useGeneratePdf(
  title?: string,
  orientation: 'l' | 'p' = 'l'
) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState<'idle' | 'generating' | 'generated'>(
    'idle'
  );

  useEffect(() => {
    setStatus('idle');
  }, [title]);

  const generatePdf = useCallback(
    async (filename: string) => {
      setStatus('generating');
      try {
        await generatePDF(contentRef, {
          filename,
          page: { orientation },
          resolution: Resolution.NORMAL,
        });
        setStatus('generated');
      } catch (error) {
        sentry.log(error);
        console.error('PDF generation failed:', error);
        setStatus('idle');
      }
    },
    [orientation]
  );

  useEffect(() => {
    if (!title) return;

    const timeoutId = setTimeout(() => {
      void generatePdf(`${title}.pdf`);
    }, 5000);
    return () => clearTimeout(timeoutId);
  }, [generatePdf, title]);

  return {
    contentRef,
    status,
  };
}
